document.addEventListener('DOMContentLoaded', function() {
  // Function to handle the auto-closing of menus
  function setupAutoCloseMenus() {
    // Get all menu triggers
    const menuTriggers = document.querySelectorAll('.collapsible-trigger');
    
    // Add click event listener to each trigger
    menuTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(event) {
        // Prevent multiple handling
        event.stopPropagation();
        
        // Get the current trigger's parent level
        const isTopLevel = trigger.classList.contains('mobile-nav__link--top-level') || 
                          trigger.classList.contains('mobile-master-collection-item');
        
        // Get all open triggers at the same level
        let openTriggers;
        if (isTopLevel) {
          openTriggers = document.querySelectorAll('.mobile-nav__link--top-level.is-open, .mobile-master-collection-item.is-open');
        } else {
          // For submenus, only close siblings within the same parent list
          const parentList = trigger.closest('.mobile-nav__sublist');
          if (parentList) {
            openTriggers = parentList.querySelectorAll('.collapsible-trigger.is-open');
          } else {
            openTriggers = [];
          }
        }
        
        // Close other open menus at the same level
        openTriggers.forEach(openTrigger => {
          // Don't close the one that was just clicked
          if (openTrigger !== trigger) {
            // Remove the is-open class
            openTrigger.classList.remove('is-open');
            if (openTrigger.hasAttribute('aria-open')) {
              openTrigger.removeAttribute('aria-open');
            }
            
            // Find and collapse the content panel
            const controlledElement = document.getElementById(openTrigger.getAttribute('aria-controls'));
            if (controlledElement) {
              controlledElement.classList.remove('is-open');
              controlledElement.style.height = '0';
            }
          }
        });
      });
    });
  }
  
  // Run the setup
  setupAutoCloseMenus();
  
  // Re-run on ajax cart updates or other dynamic changes
  document.addEventListener('theme:cart:updated', setupAutoCloseMenus);
});